export const originsConfig = {
  opentix: { label: 'OPENTIX', value: 'opentix' },
  pospal: { label: 'PosPal', value: 'pospal' },
  weiby: { label: 'Weiby', value: 'weiby' },
  drfoot: { label: 'DrFoot', value: 'drfoot' },
  dudoo: { label: 'Dudoo', value: 'dudoo' },
  pos303: { label: 'POS303', value: 'pos303' },
  cyjPos: { label: 'CYJ 凱惠', value: 'cyjPos' },

}

export const salesItemFieldConfig = {
  opentix: {
    name: { label: '場次名稱' },
    eventTimeRange: { label: '場次起迄時間' },
  },
}

export const memberExternalTransactionStatusConfig = {
  pending: { label: '訂單處理中', value: 'pending', type: 'info' },
  created: { label: '訂單完成', value: 'created', type: 'action' },
  invalid: { label: '訂單取消', value: 'invalid', type: 'danger' },
  voided: { label: '訂單作廢', value: 'voided', type: 'danger' },
  refunded: { label: '訂單退貨', value: 'refunded', type: 'danger' },
}

export const markedStatusConfig = {
  manualInvalid: { label: '標記作廢', value: 'manualInvalid', type: 'danger', optionLabel: '後台標記作廢' },
  systemInvalid: { label: '標記作廢', value: 'systemInvalid', type: 'danger', optionLabel: 'POS標記作廢' },
}

export const memberExternalTransactionTypeConfig = {
  userOrder: { label: '一般訂單', value: 'userOrder' },
  userOrderVoid: { label: '訂單作廢', value: 'userOrderVoid' },
  userOrderRefund: { label: '訂單退貨', value: 'userOrderRefund' },
}
